import { render, staticRenderFns } from "./EkTedaviIslemleri.vue?vue&type=template&id=6a1a6c08&scoped=true&"
import script from "./EkTedaviIslemleri.vue?vue&type=script&lang=js&"
export * from "./EkTedaviIslemleri.vue?vue&type=script&lang=js&"
import style0 from "./EkTedaviIslemleri.vue?vue&type=style&index=0&id=6a1a6c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a6c08",
  null
  
)

export default component.exports